import './App.css';
import React, {useLayoutEffect} from "react";
import {BrowserRouter, Routes, Route, useLocation} from "react-router-dom"
import Work from "./components/work/Work";
import About from "./components/about/About";
import Contact from "./components/contact/Contact";
import LandingPage from "./components/landingpage/LandingPage";
import Home from "./components/home/Home";
import SocialMedia from './components/services/socialmedia/SocialMedia';
import Event from './components/services/event/Event';
import Promotional from './components/services/promotional/Promotional';
import Wedding from './components/services/wedding/Wedding';
import Summary from './components/summary/Summary';

function App() {

    const ScrollToTop = ({children}) => {
        const location = useLocation();
        useLayoutEffect(() => {
            document.documentElement.scrollTo(0, 0);
        }, [location.pathname]);
        return children
    }

    return (
      <>
          <BrowserRouter>
              <ScrollToTop>
                  <Routes>
                      <Route path="/" element={<Home />}>
                          <Route index element={<LandingPage />} />
                          <Route path="about" element={<About />} />
                          <Route path="work" element={<Work />} />
                          <Route path="contact" element={<Contact />} />
                          <Route path="services/promotional" element={<Promotional />} />
                          <Route path="services/event" element={<Event />} />
                          <Route path="services/social-media" element={<SocialMedia />} />
                          <Route path="services/wedding" element={<Wedding />} />
                          <Route path="summary" element={<Summary />} />
                      </Route>
                  </Routes>
              </ScrollToTop>
          </BrowserRouter>
      </>
  );
}

export default App;
